import { IdToken } from "@/core/models/id-token.model";
import { Injectable } from "@angular/core";
import { IdTokenRepository } from "./abstractions/id-token.repository";
import { GetTokenResponse } from "./abstractions/token.repository";

@Injectable({
    providedIn: 'root'
})
export class LocalStorageIdTokenRepository extends IdTokenRepository {
    public get(): GetTokenResponse<string, IdToken> {
        let jwtToken: string | null = localStorage.getItem(IdToken.name);

        let response: GetTokenResponse<string, IdToken> = new GetTokenResponse<string, IdToken>();

        if (jwtToken) {
            try {
                const accessToken = new IdToken(jwtToken);
                response.token = accessToken;
            } catch (e) {
                this.delete()
            }
        }

        return response;
    }

    public save(idToken: IdToken) {
        localStorage.setItem(IdToken.name, idToken.toJwtToken());
    }

    public delete() {
        localStorage.removeItem(IdToken.name);
    }
}